import PropTypes from 'prop-types';

export const SizeProps = PropTypes.oneOf(['lg', 'md', 'sm', 'xs', 'xxs']);
